import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TerpecaUser } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import {
    discordUsernameValidator, escapeAllGrUserIdValidator, escapeGameFrUserIdValidator, escapeRoomersUserIdValidator,
    escapeTalkNlUserIdValidator, escapeTheReviewUserIdValidator, facebookUsernameValidator, instagramUsernameValidator,
    linkedinUsernameValidator, lockMeUserIdValidator, mortyAppUsernameValidator, theEscapersUserIdValidator
} from 'src/app/utils/form.utils';

@Component({
  selector: 'app-editapplicantdialog',
  standalone: false,
  templateUrl: './editapplicantdialog.component.html',
  styleUrl: './editapplicantdialog.component.css'
})
export class EditApplicantDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<EditApplicantDialogComponent>>(MatDialogRef);
  private auth = inject(AuthService);
  data = inject(MAT_DIALOG_DATA);

  form: UntypedFormGroup;
  user: TerpecaUser = this.data.user;

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      realName: new UntypedFormControl('', Validators.required),
      city: new UntypedFormControl('', Validators.required),
      state: new UntypedFormControl(''),
      country: new UntypedFormControl('', Validators.required),
      irlRoomCount: new UntypedFormControl('', [Validators.required, Validators.min(1)]),
      bio: new UntypedFormControl('', Validators.required),
      facebookUsername: new UntypedFormControl('', facebookUsernameValidator),
      instagramUsername: new UntypedFormControl('', instagramUsernameValidator),
      discordUsername: new UntypedFormControl('', discordUsernameValidator),
      linkedinUsername: new UntypedFormControl('', linkedinUsernameValidator),
      mortyAppUsername: new UntypedFormControl('', mortyAppUsernameValidator),
      escapeTheReviewUserId: new UntypedFormControl('', escapeTheReviewUserIdValidator),
      escapeAllGrUserId: new UntypedFormControl('', escapeAllGrUserIdValidator),
      escapeGameFrUserId: new UntypedFormControl('', escapeGameFrUserIdValidator),
      escapeRoomersUserId: new UntypedFormControl('', escapeRoomersUserIdValidator),
      escapeTalkNlUserId: new UntypedFormControl('', escapeTalkNlUserIdValidator),
      lockMeUserId: new UntypedFormControl('', lockMeUserIdValidator),
      theEscapersUserId: new UntypedFormControl('', theEscapersUserIdValidator)
    });
    this.form.patchValue(this.user);
  }

  formIsValid(): boolean {
    return this.form.valid && this.form.dirty;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  async submit() {
    if (!this.formIsValid()) {
      return;
    }
    await this.auth.editApplicantFields(this.user.uid, this.user, this.form.value);
    this.dialogRef.close(true);
  }
}
